import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "mx-auto max-w-2xl lg:max-w-7xl" }
const _hoisted_3 = {
  role: "list",
  class: "flex flex-col gap-y-4 text-balance"
}
const _hoisted_4 = { class: "flex gap-x-3" }

import type { SimpleListElementProps } from "./SimpleListElementProps";
import type { PageBlock } from "@/views/blocks/PageBlock.interface";
import type { ScrollAnimationType } from "@/apps/page/page-project.interface";
import EditableElement from "@/views/page/EditableElement.vue";
import Image from "@/views/blocks/shared/section/media/image/Image.vue";
import ScrollAnimation from "@/views/blocks/shared/section/animations/ScrollAnimation.vue";
import { computed } from "vue";
import HorizontalSpacing from "@/views/blocks/shared/section/layout/spacing/HorizontalSpacing.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'SimpleListElement',
  props: {
    block: {},
    scrollAnimationType: {}
  },
  setup(__props: any) {

const props = __props;

const dataValues = computed(() => props.block.dataValues);
const styleValues = computed(() => props.block.styleValues);

const imageSize = computed(() => {
    const textSize = dataValues.value.formatting.data.textSize;
    const sizeMap: Record<string, { class: string; width: number; height: number }> = {
        "text-sm": { class: "size-4", width: 16, height: 16 },
        "text-base": { class: "size-5", width: 20, height: 20 },
        "text-lg": { class: "size-6", width: 24, height: 24 },
        "text-xl": { class: "size-7", width: 28, height: 28 },
        "text-2xl": { class: "size-8", width: 32, height: 32 },
        "text-3xl": { class: "size-9", width: 36, height: 36 },
    };
    return sizeMap[textSize] || sizeMap["text-base"];
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ScrollAnimation, { type: _ctx.scrollAnimationType }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        id: _ctx.block.webId,
        style: _normalizeStyle({
                backgroundColor: styleValues.value.background,
            })
      }, [
        _createVNode(HorizontalSpacing, {
          class: _normalizeClass([
                    dataValues.value.formatting.data.paddingTop,
                    dataValues.value.formatting.data.paddingBottom,
                ])
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", {
                class: _normalizeClass([
                            dataValues.value.formatting.data.elementAlign,
                            dataValues.value.formatting.data.maxWidth,
                        ])
              }, [
                _createElementVNode("ul", _hoisted_3, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataValues.value.items.data.items, (item) => {
                    return (_openBlock(), _createBlock(EditableElement, {
                      key: item.id,
                      blockId: _ctx.block.id,
                      fieldName: `items_${item.id}`,
                      hideable: false
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("li", _hoisted_4, [
                          _createVNode(Image, {
                            src: item.iconSrc,
                            alt: "",
                            class: _normalizeClass(['mt-[2px] flex-none', imageSize.value.class]),
                            width: imageSize.value.width,
                            height: imageSize.value.height,
                            "aria-hidden": "true"
                          }, null, 8, ["src", "class", "width", "height"]),
                          _createElementVNode("span", {
                            class: _normalizeClass(dataValues.value.formatting.data.textSize)
                          }, [
                            _createElementVNode("strong", {
                              style: _normalizeStyle({ color: styleValues.value.text })
                            }, _toDisplayString(item.title), 5),
                            _cache[0] || (_cache[0] = _createTextVNode(" " + _toDisplayString(" ") + " ")),
                            _createElementVNode("span", {
                              class: "opacity-70",
                              style: _normalizeStyle({ color: styleValues.value.text })
                            }, _toDisplayString(item.description), 5)
                          ], 2)
                        ])
                      ]),
                      _: 2
                    }, 1032, ["blockId", "fieldName"]))
                  }), 128))
                ])
              ], 2)
            ])
          ]),
          _: 1
        }, 8, ["class"])
      ], 12, _hoisted_1)
    ]),
    _: 1
  }, 8, ["type"]))
}
}

})